import { Component, Inject } from '@angular/core';
import { OKTA_AUTH, OktaAuthStateService } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';
import { Router, NavigationStart} from '@angular/router';
import { environment } from '../environments/environment.prod';
import { Location } from '@angular/common';
import { AuthService } from '../app/services/auth.service';

import { SignupuserService } from './services/signupuser.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DOCUMENT } from '@angular/common';
import { ClowderService } from "./services/clowder.service";
import { ProgramService } from './services/program.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {
  title = 'storen-satisfaction';
  event$:any;

    constructor(public authStateService: OktaAuthStateService,private programService:ProgramService, private _clowderService:ClowderService,@Inject(DOCUMENT) private document: Document,private location: Location, @Inject(OKTA_AUTH) private oktaAuth: OktaAuth, private router: Router, private authService: AuthService) {
    const hostDt = window.location.hostname;
  if(hostDt == 'https://storensatisfaction.com'){
         // this.document.location.hostname.replace('storensatisfaction.com', 'www.storensatisfaction.com');
      //this.document.location.hostname.replace('www.storensatisfaction.com');
    //window.location.replace('http://www.storensatisfaction.com');
    const updatedUrl = 'https://www.storensatisfaction.com' + window.location.pathname + window.location.search;
    this.router.navigateByUrl(updatedUrl, { replaceUrl: true });
    }
  }
   ngOnInit(){
    if ( window ) {
      console.log = function(){};
      }
     this.getPostLoginToken();
     this.checkSession();
     const authenticated = this.oktaAuth.isAuthenticated();
   }
  getPostLoginToken() {
    
    this.authService.postLoginTokenUserApi().subscribe(res => {
      localStorage.setItem('APIKeyUserAPI', res.Token);
    });
    this.authService.postLoginTokenSnapApi().subscribe(res => {
      localStorage.setItem('APIKeySNAPAPI', res.Token);
    });
    this._clowderService.getAuthToken().subscribe(res => {
      localStorage['Token'] = res.id_token;
    }, (error) => {
      this.errorCaptureDB(error);
    })
    // this.programService.postLoginTokenEbiz().subscribe(res => {
    //   localStorage['APIKey'] = res?.Token;
    // });      
  }

  errorCaptureDB(error: any) {
    this.programService.errorDetailsLog(JSON.stringify(error), "Error in Dataloop Authenication").subscribe(res => {
    }, (error) => {
      console.error('Error saving dataloop API :', error);
    });
  }
  async checkSession() {
    try {
      const isAuthenticated = await this.oktaAuth.isAuthenticated();
      if (isAuthenticated) {
        
        this.router.navigate(['/program']);
      }
    } catch (error) {
      console.error('Error checking authentication status', error);
    }
  }
   //async login() {
   //  await this.oktaAuth.signInWithRedirect({ originalUri: '/' });
   //}
  

}
